import React from 'react';
import { Logo } from '../Logo';
export function LandingFooter() {
  return <footer className="border-t border-line" data-id="element-114" data-mp="lofyi7dufpal">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-115" data-mp="lpqx7ssfm6uu">
        <Logo data-id="element-116" data-mp="gvv0surtgs1s" />
        <div className="flex gap-6 text-sm text-muted" data-id="element-117" data-mp="gvd0nn219tol">
          <a href="mailto:hello@localtask.cc" className="transition-colors duration-150 hover:text-ink" data-id="element-118" data-mp="bxtkghlrz6u0">hello@localtask.cc</a>
          <span data-id="element-119" data-mp="6xfbmxccnsux">© 2026 LocalTask, Inc.</span>
        </div>
      </div>
    </footer>;
}